module.exports = __webpack_public_path__ + "static/media/user.50b8859c.jpg";